(() => {
  const STORAGE_PREFIX = 'stow-bespoke-enquiry:';

  const createSubmissionId = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `bespoke-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  };

  const text = (formData, name) => String(formData.get(`contact[${name}]`) || '').trim();

  const storageKey = (form) => `${STORAGE_PREFIX}${form.id || 'form'}`;

  const buildPayload = (form) => {
    const formData = new FormData(form);
    const submissionId = createSubmissionId();
    const firstName = text(formData, 'First name');
    const lastName = text(formData, 'Last name');
    const product = text(formData, 'Product');
    const layout = text(formData, 'Layout');
    const notes = [
      text(formData, 'Additional notes'),
      text(formData, 'Drawer positioning'),
      text(formData, 'Skirting notes'),
      text(formData, 'Postcode') ? `Postcode: ${text(formData, 'Postcode')}` : '',
    ].filter(Boolean).join('\n');

    return {
      shop: window.Shopify?.shop || '',
      source: product ? 'product_configurator' : 'standalone_configurator',
      external_submission_id: submissionId,
      customer_name: [firstName, lastName].filter(Boolean).join(' ') || text(formData, 'name'),
      customer_email: text(formData, 'email'),
      customer_phone: text(formData, 'phone'),
      style: text(formData, 'Style') || product,
      layout,
      storage: text(formData, 'Storage'),
      fabric: text(formData, 'Fabric / Colour'),
      dimensions: {
        length: text(formData, 'A Length (mm)'),
        depth_or_short_side: layout.toLowerCase().includes('straight')
          ? text(formData, 'B Total Depth (mm)')
          : text(formData, 'C Short Side Length (mm)'),
        overall_height: text(formData, 'E Overall Height (mm)'),
      },
      skirting: text(formData, 'Skirting cut-outs'),
      customer_notes: notes,
      prompt_text: text(formData, 'AI Visualisation Brief'),
    };
  };

  const rememberSubmission = (form) => {
    if (!form.checkValidity()) return;
    try {
      window.sessionStorage.setItem(storageKey(form), JSON.stringify(buildPayload(form)));
    } catch (_error) {
      // The Shopify contact submission remains the customer-facing system of record.
    }
  };

  const syncConfirmedSubmission = async (configurator) => {
    const form = configurator.querySelector('form');
    const success = configurator.querySelector('[data-form-success]');
    if (!form || !success) return;

    let payload;
    try {
      payload = JSON.parse(window.sessionStorage.getItem(storageKey(form)) || 'null');
    } catch (_error) {
      return;
    }
    if (!payload?.external_submission_id) return;

    try {
      const response = await fetch('/apps/bespoke-enquiries/submit', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      });
      if (!response.ok) return;
      window.sessionStorage.removeItem(storageKey(form));
    } catch (_error) {
      // Never make an internal-copy failure look like a failed customer enquiry.
    }
  };

  const initialise = () => {
    document.querySelectorAll('bespoke-quote-configurator').forEach((configurator) => {
      const form = configurator.querySelector('form');
      form?.addEventListener('submit', () => rememberSubmission(form));
      syncConfirmedSubmission(configurator);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
